// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, timesheetFieldService } from "../../../app/rpc"
import {
  BatchGetTimesheetFieldOptionsRequestSchema,
  BatchGetTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type BatchGetTimesheetFieldOptionsRpc = (request: Init<typeof BatchGetTimesheetFieldOptionsRequestSchema>) => Observable<BatchGetTimesheetFieldOptionsResponse>

export const batchGetTimesheetFieldOptions = (batchGetTimesheetFieldOptionsRpc: BatchGetTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.batchGetTimesheetFieldOptions.match),
      mergeMap(action => batchGetTimesheetFieldOptionsRpc(action.payload)
        .pipe(
          map(t => t.timesheetFieldOptions),
          map(Slice.setTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_batch_get_timesheet_field_options_failed",
              message: "Failed to load timesheet field values. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const batchGetTimesheetFieldOptionsRpc = (request: Init<typeof BatchGetTimesheetFieldOptionsRequestSchema>): Observable<BatchGetTimesheetFieldOptionsResponse> =>
  executor(() => timesheetFieldService.batchGetTimesheetFieldOptions(create(BatchGetTimesheetFieldOptionsRequestSchema, request)))

export default batchGetTimesheetFieldOptions(batchGetTimesheetFieldOptionsRpc)
